<template>
  <div id='tyc' >
   
  </div>
</template>

<style>
#tyc{display: inline;}
</style>
 
<script>
  export default{
    data () {
      return { 
        terminalTypes: [
          {lb: this.$t('lin_global.all_status'), vl: ''},
          {lb: this.$t('app_online'), vl: '1'},
          {lb: this.$t('app_offline'), vl: '2'},
          {lb: this.$t('app_new'), vl: '0'},
          {lb: this.$t('app_sleep'), vl: '3'},
          // {lb: this.$t('lin_btn.lock'), vl: '4'}
        ],
        terminalType: {
          '': this.$t('lin_global.all_status'),
          '0': this.$t('app_new'),
          '1': this.$t('app_online'),
          '2': this.$t('app_offline'),
          '3': this.$t('app_sleep'),
          // '4': this.$t('lin_btn.lock')
        },
        nonTerType: {
          '': this.$t('lin_global.all_status'),
          '0': this.$t('app_new'),
          '1': this.$t('app_enable')
        },
				nonTerTypes: [
          {vl:'', lb: this.$t('lin_global.all_status')},
          {vl:'0', lb: this.$t('app_new')},
          {vl:'1', lb: this.$t('app_enable')}
        ],
        openplAuth: {
          '': this.$t('lin_global.all_status'),
          '0': this.$t('app_open1'),
          '1': this.$t('app_close')
        },
        openplAuths: [
          {vl:'', lb: this.$t('lin_global.all_status')},
          {vl:'0', lb: this.$t('app_open1')},
          {vl: '1', lb: this.$t('app_close')}
        ],
        taskType: { 
          "1" : this.$t('terminal.details.app_install'),
          "2" : this.$t('app_sysud'),
          // "3" : 'ROM'+this.$t('lin_btn.send'),
          "4" : this.$t('app_fmwud'),
          "5" : this.$t('app_advpush'),
          "6" : this.$t('app_anmud'),
          "7" : this.$t('app_anmud'),
          "8" : this.$t('app_anmud'),
          "9" : this.$t('app_anmud'),
          "10" : 'launcher'+this.$t('app_update'),
          "11" : this.$t('app_anmud'),
          "12" : this.$t('app_appuninstall'),
          // "13" : this.$t('app_stfpush'),
          "14" : this.$t('app_qcgunsrcps'),
          "15" : this.$t('app_qcgunsrcps'),
          "16" : 'cfg'+this.$t('lin_btn.send'),
          "18" : 'linux' + this.$t('app_srcfileps')
        },
        taskTypeArr: [ 
          {type: "", name: this.$t('taskTypeNames.ALL')},
          {type:"1", name: this.$t('terminal.details.app_install')},
          {type:"2", name: this.$t('app_sysud')},
          // {type:"3", name: 'ROM'+this.$t('lin_btn.send')},
          {type:"4", name: this.$t('app_fmwud')},
          {type:"5", name: this.$t('app_advpush')},
          {type:"6", name: this.$t('app_anmud')},
          // {type:"7", name: this.$t('app_anmud')},
          // {type:"8", name: this.$t('app_anmud')},
          // {type:"9", name: this.$t('app_anmud')},
          {type:"10", name: 'launcher'+this.$t('app_update')},
          // {type:"11", name: this.$t('app_anmud')},
          {type:"12", name: this.$t('app_appuninstall')},
          // {type:"13", name: this.$t('app_stfpush')},
          {type:"14", name: this.$t('app_qcgunsrcps')}, 
          // {type:"15", name: this.$t('app_qcgunsrcps')},
          {type:"16", name: 'cfg'+this.$t('lin_btn.send')},
          {type:"18", name: 'linux' + this.$t('app_srcfileps')}
        ],
        taskTypeArr1: [ 
          {type: "", name: this.$t('taskTypeNames.ALL')},
          {type:"1", name: "OTA"},
          {type:"2", name: this.$t('app_firmw')},
          {type:"3", name: this.$t('app_animation')},
          {type:"4", name: "launcher"},
          {type:"5", name: 'cfg ' + this.$t('app_file')},
		  {type:"12", name: this.$t('app_rtosgunsrc')},
          {type:"7", name: this.$t('app_app')},
          {type:"8", name: 'linux ' + this.$t('app_app')},
          {type:"9", name: this.$t('app_commpush')},
          {type:"10", name: 'linux ' + this.$t('app_firmw')},
          {type:"11", name: this.$t('app_filepush')},
		  {type:"6", name: this.$t('app_codegunsrc')}
        ],
				taskTypeArr1_1: [
				    {type:"1", name: "OTA"},
				    {type:"2", name: this.$t('app_firmw')},
				    {type:"3", name: this.$t('app_animation')},
				    {type:"4", name: "launcher"},
				    {type:"5", name: 'cfg ' + this.$t('app_file')},
				    {type:"7", name: this.$t('app_app')},
				    {type:"8", name: 'linux ' + this.$t('app_app')},
				    {type:"9", name: this.$t('app_commpush')},
				    {type:"10", name: 'linux ' + this.$t('app_firmw')},
				    {type:"11", name: this.$t('app_filepush')},
				  ],
					taskTypeArr1_2: [
					{type:"12", name: this.$t('app_rtosgunsrc')},
					{type:"6", name: this.$t('app_codegunsrc')}
					  ],
        taskTypeArr2: [ 
          {type: "", name: this.$t('taskTypeNames.ALL')},
          {type:"1", name: this.$t('app_apppush')},
          {type:"2", name: 'OTA' + this.$t('lin_btn.send')},
          // {type:"3", name: 'ROM'+this.$t('lin_btn.send')},
          {type:"4", name: this.$t('app_fmwpush')},
          // {type:"5", name: this.$t('app_advpush')},
          {type:"6", name: this.$t('app_animatePush')},
          // {type:"7", name: this.$t('app_anmud')},
          // {type:"8", name: this.$t('app_anmud')},
          // {type:"9", name: this.$t('app_anmud')},
          {type:"10", name: 'launcher'+this.$t('lin_btn.send')},
          // {type:"11", name: this.$t('app_wppush')},
          // {type:"12", name: this.$t('app_appuninstall')},
          // {type:"13", name: this.$t('app_configfile')},
          {type:"14", name: this.$t('app_qcgunsrcps')}, 
          {type:"15", name: this.$t('app_mstype15')},
          {type:"16", name: 'cfg'+this.$t('lin_btn.send')},
          {type:"18", name: 'linux ' + this.$t('app_app')},
          {type:"19", name: this.$t('app_commpush')},
          {type:'20', name: 'linux ' + this.$t('app_firmw')},
          {type:'21', name: this.$t('app_filepush')}
        ],
        taskType2: {
          "": this.$t('taskTypeNames.ALL'),
          "1": this.$t('app_apppush'),
          "2": 'OTA' + this.$t('lin_btn.send'),
          // "3": 'ROM'+this.$t('lin_btn.send'),
          "4": this.$t('app_fmwpush'),
          // "5": this.$t('app_advpush'),
          "6": this.$t('app_animatePush'),
          "7": this.$t('app_animatePush'),  /// 原动画更新
          "8": this.$t('app_animatePush'),  /// 原动画更新
          "9": this.$t('app_animatePush'),  /// 原动画更新
          "10": 'launcher'+this.$t('lin_btn.send'),
          "11": this.$t('app_wppush'),
          "12": this.$t('app_appuninstall'),
          // "13": this.$t('app_configfile'),
          "14": this.$t('app_qcgunsrcps'), 
          "15": this.$t('app_mstype15'),
          "16": 'cfg'+this.$t('lin_btn.send'),
          "18": 'linux ' + this.$t('app_app'),
          "19": this.$t('app_commpush'),
          '20': 'linux ' + this.$t('app_firmw'),
          '21': this.$t('app_filepush')
        },
        comms: [
          {lb: this.$t('app_dvrestart'), vl: 'CQ'},
          {lb: this.$t('app_recvorgst'), vl: 'HFCCSZ'},
          {lb: this.$t('app_recvanimt'), vl: 'HYDH'},
          {lb: this.$t('app_recov') + 'launcher', vl: 'QCZM'},
          {lb: this.$t('app_dvlock'), vl: 'SJ'},
          {lb: this.$t('app_dvunlock'), vl: 'JS'},
          {lb: this.$t('app_pusheddvlist'), vl: 'XZYY'},
          {lb: this.$t('app_lcswitch'), vl: 'ZQ'}
        ],
        comms1: [
          {lb: this.$t('app_dvrestart'), vl: 'CQ'},
          {lb: this.$t('app_recvorgst'), vl: 'HFCCSZ'},
          {lb: this.$t('app_recvanimt'), vl: 'HYDH'},
          {lb: this.$t('app_recov') + 'launcher', vl: 'QCZM'},
          {lb: this.$t('app_dvlock'), vl: 'SJ'},
          {lb: this.$t('app_dvunlock'), vl: 'JS'},
          {lb: this.$t('app_pusheddvlist'), vl: 'XZYY'},
          {lb: this.$t('app_lcswitch'), vl: 'ZQ'},
          {lb: this.$t('terminal.details.open_abd'), vl: 'ADBCTL-OPEN'},
          {lb: this.$t('terminal.details.close_abd'), vl: 'ADBCTL-CLOSE'},
          {lb: this.$t('app_openCerCheck'), vl: 'YQCTL-OPEN'},
          {lb: this.$t('app_closeCerCheck'), vl: 'YQCTL-CLOSE'}
        ],
        comm: {
          'CQ': this.$t('app_dvrestart'),
          'HFCCSZ': this.$t('app_recvorgst'), 
          'HYDH': this.$t('app_recvanimt'),
          'QCZM': this.$t('app_recov') + 'launcher',
          'SJ': this.$t('app_dvlock'), 
          'JS': this.$t('app_dvunlock'),
          'XZYY': this.$t('app_pusheddvlist'),
          'ZQ': this.$t('app_lcswitch'),
          'ADBCTL-OPEN': this.$t('terminal.details.open_abd'),
          'ADBCTL-CLOSE': this.$t('terminal.details.close_abd'),
          'YQCTL-OPEN': this.$t('app_openCerCheck'),
          'YQCTL-CLOSE': this.$t('app_closeCerCheck')
        },
        appVSts: [
          { label: this.$t("app_prePushVerify"), value: "0" },
          { label: this.$t("app_preVerify"), value: "1" },
          { label: this.$t("app_verifyPass"), value: "2" },
          { label: this.$t("app_verifyNotPass"), value: "3" }
        ],
        appVSt: {
          "0": this.$t("app_prePushVerify"),
          "1": this.$t("app_preVerify"),
          "2": this.$t("app_verifyPass"), 
          "3": this.$t("app_verifyNotPass")
        },
        nolcft: [
          // {vl: '', lb: this.$t('app_alltyps')},
          {vl: '1', lb: 'OTA'},
          {vl: '2', lb: this.$t('app_firmw')},
          {vl: '3', lb: this.$t('app_animation')},
          {vl: '5', lb: 'CFG' + this.$t('app_file')}, 
		  {vl: '11', lb: this.$t('app_rtosgunsrc')},
          {vl: '7', lb: this.$t('app_app')},
          {vl: '8', lb: 'linux ' + this.$t('app_app')},
          {vl: '9', lb: 'linux ' + this.$t('app_firmw')},
          {vl: '10', lb: this.$t('app_file')},
		  {vl: '6', lb: this.$t('app_codegunsrc')},
        ],
		nolcft_1: [
		  {vl: '1', lb: 'OTA'},
		  {vl: '2', lb: this.$t('app_firmw')},
		  {vl: '3', lb: this.$t('app_animation')},
		  {vl: '5', lb: 'CFG' + this.$t('app_file')}, 
		  {vl: '7', lb: this.$t('app_app')},
		  {vl: '8', lb: 'linux ' + this.$t('app_app')},
		  {vl: '9', lb: 'linux ' + this.$t('app_firmw')},
		  {vl: '10', lb: this.$t('app_file')},
		],
		nolcft_2: [
		  {vl: '11', lb: this.$t('app_rtosgunsrc')},
		  {vl: '6', lb: this.$t('app_codegunsrc')},
		],
        ftypes: [
          // {vl: '', lb: this.$t('app_alltyps')},
          {vl: '1', lb: 'OTA'},
          {vl: '2', lb: this.$t('app_firmw')},
          {vl: '3', lb: this.$t('app_animation')},
          {vl: '4', lb: 'launcher'},
          {vl: '5', lb: 'CFG' + this.$t('app_file')},
		  {vl: '11', lb: this.$t('app_rtosgunsrc')},
          {vl: '7', lb: this.$t('app_app')},
          {vl: '8', lb: 'linux ' + this.$t('app_app')},
          {vl: '9', lb: 'linux ' + this.$t('app_firmw')},
          {vl: '10', lb: this.$t('app_file')},
		  {vl: '6', lb: this.$t('app_codegunsrc')},
        ],
        ftype: {
          '1': 'OTA',
          '2': this.$t('app_firmw'),
          '3': this.$t('app_animation'),
          '4': 'launcher',
          '5': 'CFG' + this.$t('app_file'),
          '6': this.$t('app_codegunsrc'),
          '7': this.$t('app_app'),
          '8': 'linux ' + this.$t('app_app'),
          '9': 'linux ' + this.$t('app_firmw'),
          '10': this.$t('app_file'),
          '11': this.$t('app_rtosgunsrc'),
        },
        sftype: {
          '1-0': 'OTA' + this.$t('app_ttPkg'),
          '1-1': 'OTA' + this.$t('app_partpkg'),
          '2-KSP': 'KSP' + this.$t('app_firmw'),
          "2-RES": 'RES' + this.$t('app_firmw'),
          '2-HEX': 'HEX' + this.$t('app_firmw'),
          '2-KOS': 'KOS' + this.$t('app_firmw'),
          '2-FLAS':'FLAS' + this.$t('app_firmw'),
          '2-KEY': 'KEY' + this.$t('app_firmw'),
          '3-1': this.$t('terminal.details.kjdh'),
          '3-2': this.$t('terminal.details.gjdh'),
          '3-3': this.$t('app_launchAnimate'),
          '3-4': this.$t('app_onLogo'),
          '3-5': this.$t('app_deskwp'),
          '6-1': this.$t('app_codegunapp'),
          '6-2': this.$t('app_codegunsrc'),
          '9-1': this.$t('app_core'),
          '9-2': this.$t('app_filesys'),
          '9-3': 'H330S ' + this.$t('app_firmw'),
          '9-4': 'G510 ' + this.$t('app_firmw'),
          '9-5': 'Max32555 ' + this.$t('app_firmw'),
          '11-1': this.$t('app_rots_1'),
          '11-3': this.$t('app_rots_3'),
          '11-4': this.$t('app_rots_4'),
          '11-5': this.$t('app_rots_5'),
        },
        sftypes1: [
          {vl: '', lb: this.$t('app_allstyps')},
          {vl: '1-0', lb: 'OTA' + this.$t('app_ttPkg')},
          {vl: '1-1', lb: 'OTA' + this.$t('app_partpkg')}
        ],
        sftypes2: [
          {vl: '', lb: this.$t('app_allstyps')},
          {vl: '2-KSP', lb: 'KSP' + this.$t('app_firmw')},
          {vl: '2-RES', lb: 'RES' + this.$t('app_firmw')},
          {vl: '2-HEX', lb: 'HEX' + this.$t('app_firmw')},
          {vl: '2-KOS', lb: 'KOS' + this.$t('app_firmw')},
          {vl: '2-FLAS', lb: 'FLAS' + this.$t('app_firmw')},
          {vl: '2-KEY', lb: 'KEY' + this.$t('app_firmw')}
        ],
        sftypes3: [
          {vl: '', lb: this.$t('app_allstyps')},
          {vl: '3-1', lb: this.$t('terminal.details.kjdh')},
          {vl: '3-2', lb: this.$t('terminal.details.gjdh')},
          {vl: '3-3', lb: this.$t('app_launchAnimate')},
          {vl: '3-4', lb: this.$t('app_onLogo')},
          {vl: '3-5', lb: this.$t('app_deskwp')}
        ],
        sftypes5: [
          {vl: '', lb: this.$t('app_allstyps')}
        ],
        sftypes6: [
          {vl: '', lb: this.$t('app_allstyps')},
          {vl: '6-1', lb: this.$t('app_codegunapp')},
          {vl: '6-2', lb: this.$t('app_codegunsrc')}
        ],
        sftypes7: [
		{vl: '', lb: this.$t('app_allstyps')}
        ],
        sftypes9: [
          {vl: '', lb: this.$t('app_allstyps')},
          {vl: '9-1', lb: this.$t('app_core')},
          {vl: '9-2', lb: this.$t('app_filesys')},
          {vl: '9-3', lb: 'H330S ' + this.$t('app_firmw')},
          {vl: '9-4', lb: 'G510 ' + this.$t('app_firmw')},
          {vl: '9-5', lb: 'Max32555 ' + this.$t('app_firmw')}
        ],
		sftypes11: [
		  {vl: '11-1', lb: this.$t('app_rots_1')},
		  {vl: '11-3', lb: this.$t('app_rots_3')},
		  {vl: '11-4', lb: this.$t('app_rots_4')},
		  {vl: '11-5', lb: this.$t('app_rots_5')},
		]
      }
    },
    props: [
      /** 分步 */
      // 'qkey',
      // 'getTyData',
      /** 一体 */
      'tqobj'
    ],
    watch: {
      // qkey () {
      //   var fn = []
      //   var ar = this.qkey.split(',')
      //   ar.forEach(ckey => {
      //     fn.push(this[ckey])
      //   });
      //   this.getTyData(fn)
      // },
      /**推荐 */
      tqobj () {
        var fn = []
        var ar = this.tqobj.keys
        ar.forEach(ckey => {
          fn.push(this[ckey])
        });
        this.tqobj.callback(fn)
      }
    },
    computed: {
      
    },
    methods: {

   
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// tyc.vue?43df08f1